
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pass/sbsmoney",
      function () {
        return require("private-next-pages/pass/sbsmoney/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pass/sbsmoney"])
      });
    }
  